/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
  GetApiV1PersonSharedAccountTypeDropdown401,
  GetApiV1PersonSharedAccountTypeDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedAccountTypeDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedAccountTypeDropdown } from "../../clients/personSharedController/getApiV1PersonSharedAccountTypeDropdown.ts";

export const getApiV1PersonSharedAccountTypeDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/account-type-dropdown" }] as const;

export type GetApiV1PersonSharedAccountTypeDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedAccountTypeDropdownQueryKey
>;

export function getApiV1PersonSharedAccountTypeDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedAccountTypeDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAccountTypeDropdown401
      | GetApiV1PersonSharedAccountTypeDropdown500
    >,
    GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedAccountTypeDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EAccountType para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de tipos de conta bancária para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/account-type-dropdown}
 */
export function useGetApiV1PersonSharedAccountTypeDropdown<
  TData = GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonSharedAccountTypeDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedAccountTypeDropdown401
          | GetApiV1PersonSharedAccountTypeDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedAccountTypeDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedAccountTypeDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAccountTypeDropdown401
      | GetApiV1PersonSharedAccountTypeDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
